import { AuthActions, AuthActionTypes } from '../actions/auth.actions';
import { User } from '../models/user.model';

export interface AuthState {
  loggedIn: boolean;
  authToken: string;
  subject_id: string;
  user: Array<any>;
  gameplan_details: Array<any>;
  userProgress: Array<any>;
  isUserLoaded: boolean;
  is_only_bridgecourse: any
}

export const initialAuthState: AuthState = {
  loggedIn: false,
  subject_id: undefined,
  authToken: undefined,
  user: undefined,
  gameplan_details: undefined,
  userProgress: undefined,
  isUserLoaded: false,
  is_only_bridgecourse: undefined
};

export function authReducer(state = initialAuthState, action: AuthActions): AuthState {
  switch (action.type) {
    case AuthActionTypes.Login:
      return {
        ...state,
        loggedIn: true,
        authToken: action.payload.authToken,
        user: undefined,
        isUserLoaded: false
      };
    case AuthActionTypes.UserRequested:
      return {
        ...state,
        isUserLoaded: false
      };
    case AuthActionTypes.UserLoaded:
      return {
        ...state,
        user: action.payload.subject_details,
        gameplan_details: action.payload.gameplan_details,
        isUserLoaded: true
      };
    case AuthActionTypes.UserProgressRequested:
      return {
        ...state,
        subject_id: action.payload.subject_id,
        isUserLoaded: false
      };
    case AuthActionTypes.UserProgressLoaded:
      return {
        ...state,
        userProgress: action.payload.subject_details,
        isUserLoaded: true
      };
    case AuthActionTypes.AddLoginData:
      return {
        ...state,
        user: undefined,
        isUserLoaded: false,
        is_only_bridgecourse : action.payload
      };
    default:
      return state;
  }
}
